// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59, 130, 246, 0.5);
    --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
    --tw-ring-shadow: 0 0 rgba(0,0,0,0);
    --tw-shadow: 0 0 rgba(0,0,0,0);
    --tw-shadow-colored: 0 0 rgba(0,0,0,0);
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  
}
::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59, 130, 246, 0.5);
    --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
    --tw-ring-shadow: 0 0 rgba(0,0,0,0);
    --tw-shadow: 0 0 rgba(0,0,0,0);
    --tw-shadow-colored: 0 0 rgba(0,0,0,0);
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  
}
.visible {
    visibility: visible
}
.static {
    position: static
}
.fixed {
    position: fixed
}
.absolute {
    position: absolute
}
.relative {
    position: relative
}
.z-10 {
    z-index: 10
}
.-mx-4 {
    margin-left: -1rem;
    margin-right: -1rem
}
.mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem
}
.mx-auto {
    margin-left: auto;
    margin-right: auto
}
.mb-16 {
    margin-bottom: 4rem
}
.mb-2 {
    margin-bottom: 0.5rem
}
.mb-3 {
    margin-bottom: 0.75rem
}
.mb-4 {
    margin-bottom: 1rem
}
.mb-6 {
    margin-bottom: 1.5rem
}
.ml-1 {
    margin-left: 0.25rem
}
.ml-3 {
    margin-left: 0.75rem
}
.mr-1 {
    margin-right: 0.25rem
}
.mr-2 {
    margin-right: 0.5rem
}
.mt-1 {
    margin-top: 0.25rem
}
.mt-10 {
    margin-top: 2.5rem
}
.mt-12 {
    margin-top: 3rem
}
.mt-2 {
    margin-top: 0.5rem
}
.mt-3 {
    margin-top: 0.75rem
}
.mt-4 {
    margin-top: 1rem
}
.mt-5 {
    margin-top: 1.25rem
}
.mt-6 {
    margin-top: 1.5rem
}
.mt-8 {
    margin-top: 2rem
}
.block {
    display: block
}
.inline-block {
    display: inline-block
}
.flex {
    display: flex
}
.inline-flex {
    display: inline-flex
}
.table {
    display: table
}
.grid {
    display: grid
}
.hidden {
    display: none
}
.h-10 {
    height: 2.5rem
}
.h-12 {
    height: 3rem
}
.h-2 {
    height: 0.5rem
}
.h-24 {
    height: 6rem
}
.h-3 {
    height: 0.75rem
}
.h-4 {
    height: 1rem
}
.h-5 {
    height: 1.25rem
}
.h-full {
    height: 100%
}
.min-h-full {
    min-height: 100%
}
.w-10 {
    width: 2.5rem
}
.w-12 {
    width: 3rem
}
.w-2 {
    width: 0.5rem
}
.w-24 {
    width: 6rem
}
.w-3 {
    width: 0.75rem
}
.w-4 {
    width: 1rem
}
.w-5 {
    width: 1.25rem
}
.w-auto {
    width: auto
}
.w-full {
    width: 100%
}
.max-w-5xl {
    max-width: 64rem
}
.max-w-md {
    max-width: 28rem
}
.flex-1 {
    flex: 1 1 0%
}
.flex-auto {
    flex: 1 1 auto
}
.flex-none {
    flex: none
}
.shrink-0 {
    flex-shrink: 0
}
.transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
@keyframes spin {
    to {
        transform: rotate(360deg)
    }
}
.animate-spin {
    animation: spin 1s linear infinite
}
.list-inside {
    list-style-position: inside
}
.list-disc {
    list-style-type: disc
}
.appearance-none {
    -webkit-appearance: none;
            appearance: none
}
.grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr))
}
.flex-col {
    flex-direction: column
}
.flex-wrap {
    flex-wrap: wrap
}
.items-center {
    align-items: center
}
.justify-center {
    justify-content: center
}
.gap-0\\.5 {
    gap: 0.125rem
}
.gap-1 {
    gap: 0.25rem
}
.gap-2 {
    gap: 0.5rem
}
.gap-x-4 {
    column-gap: 1rem
}
.gap-y-2 {
    row-gap: 0.5rem
}
.gap-y-8 {
    row-gap: 2rem
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.25rem * (1 - var(--tw-space-y-reverse)));
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse))
}
.overflow-hidden {
    overflow: hidden
}
.overflow-x-auto {
    overflow-x: auto
}
.scroll-smooth {
    scroll-behavior: smooth
}
.break-all {
    word-break: break-all
}
.rounded {
    border-radius: 0.25rem
}
.rounded-full {
    border-radius: 9999px
}
.rounded-lg {
    border-radius: .781rem
}
.rounded-md {
    border-radius: 0.375rem
}
.border {
    border-width: 1px
}
.border-2 {
    border-width: 2px
}
.border-dashed {
    border-style: dashed
}
.border-blue-200 {
    --tw-border-opacity: 1;
    border-color: rgba(191, 219, 254, 1);
    border-color: rgba(191, 219, 254, var(--tw-border-opacity, 1))
}
.border-gray-200 {
    --tw-border-opacity: 1;
    border-color: rgba(229, 231, 235, 1);
    border-color: rgba(229, 231, 235, var(--tw-border-opacity, 1))
}
.border-gray-300 {
    --tw-border-opacity: 1;
    border-color: rgba(209, 213, 219, 1);
    border-color: rgba(209, 213, 219, var(--tw-border-opacity, 1))
}
.border-purple-200 {
    --tw-border-opacity: 1;
    border-color: rgba(233, 213, 255, 1);
    border-color: rgba(233, 213, 255, var(--tw-border-opacity, 1))
}
.border-transparent {
    border-color: transparent
}
.bg-blue-50 {
    --tw-bg-opacity: 1;
    background-color: rgba(239, 246, 255, 1);
    background-color: rgba(239, 246, 255, var(--tw-bg-opacity, 1))
}
.bg-blue-600 {
    --tw-bg-opacity: 1;
    background-color: rgba(37, 99, 235, 1);
    background-color: rgba(37, 99, 235, var(--tw-bg-opacity, 1))
}
.bg-gray-100 {
    --tw-bg-opacity: 1;
    background-color: rgba(243, 244, 246, 1);
    background-color: rgba(243, 244, 246, var(--tw-bg-opacity, 1))
}
.bg-gray-50 {
    --tw-bg-opacity: 1;
    background-color: rgba(249, 250, 251, 1);
    background-color: rgba(249, 250, 251, var(--tw-bg-opacity, 1))
}
.bg-gray-800 {
    --tw-bg-opacity: 1;
    background-color: rgba(31, 41, 55, 1);
    background-color: rgba(31, 41, 55, var(--tw-bg-opacity, 1))
}
.bg-red {
    --tw-bg-opacity: 1;
    background-color: rgba(236, 29, 36, 1);
    background-color: rgba(236, 29, 36, var(--tw-bg-opacity, 1))
}
.bg-white {
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, 1);
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1))
}
.bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--tw-gradient-stops))
}
.from-purple-50 {
    --tw-gradient-from: #faf5ff var(--tw-gradient-from-position);
    --tw-gradient-to: rgba(250, 245, 255, 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-purple-600 {
    --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
    --tw-gradient-to: rgba(147, 51, 234, 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.from-purple-700 {
    --tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
    --tw-gradient-to: rgba(126, 34, 206, 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}
.to-indigo-50 {
    --tw-gradient-to: #eef2ff var(--tw-gradient-to-position)
}
.to-indigo-600 {
    --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position)
}
.to-indigo-700 {
    --tw-gradient-to: #4338ca var(--tw-gradient-to-position)
}
.p-2 {
    padding: 0.5rem
}
.p-3 {
    padding: 0.75rem
}
.p-4 {
    padding: 1rem
}
.p-6 {
    padding: 1.5rem
}
.px-1\\.5 {
    padding-left: 0.375rem;
    padding-right: 0.375rem
}
.px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem
}
.px-3\\.5 {
    padding-left: 0.875rem;
    padding-right: 0.875rem
}
.px-4 {
    padding-left: 1rem;
    padding-right: 1rem
}
.px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem
}
.py-0\\.5 {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem
}
.py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem
}
.py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem
}
.py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem
}
.py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem
}
.py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem
}
.py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem
}
.text-left {
    text-align: left
}
.text-center {
    text-align: center
}
.text-right {
    text-align: right
}
.font-mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace
}
.text-2xl {
    font-size: 1.5rem;
    line-height: 2rem
}
.text-\\[8px\\] {
    font-size: 8px
}
.text-base {
    font-size: 1rem;
    line-height: 1.25
}
.text-lg {
    font-size: 1.125rem;
    line-height: 2rem
}
.text-sm {
    font-size: 0.875rem;
    line-height: 1.5rem
}
.text-xl {
    font-size: 1.25rem;
    line-height: 2rem
}
.text-xs {
    font-size: 0.75rem;
    line-height: 1rem
}
.font-bold {
    font-weight: 700
}
.font-medium {
    font-weight: 500
}
.font-semibold {
    font-weight: 600
}
.uppercase {
    text-transform: uppercase
}
.leading-6 {
    line-height: 1.5rem
}
.text-gray-400 {
    --tw-text-opacity: 1;
    color: rgba(156, 163, 175, 1);
    color: rgba(156, 163, 175, var(--tw-text-opacity, 1))
}
.text-gray-500 {
    --tw-text-opacity: 1;
    color: rgba(107, 114, 128, 1);
    color: rgba(107, 114, 128, var(--tw-text-opacity, 1))
}
.text-gray-600 {
    --tw-text-opacity: 1;
    color: rgba(75, 85, 99, 1);
    color: rgba(75, 85, 99, var(--tw-text-opacity, 1))
}
.text-gray-700 {
    --tw-text-opacity: 1;
    color: rgba(55, 65, 81, 1);
    color: rgba(55, 65, 81, var(--tw-text-opacity, 1))
}
.text-gray-900 {
    --tw-text-opacity: 1;
    color: rgba(17, 24, 39, 1);
    color: rgba(17, 24, 39, var(--tw-text-opacity, 1))
}
.text-purple-800 {
    --tw-text-opacity: 1;
    color: rgba(107, 33, 168, 1);
    color: rgba(107, 33, 168, var(--tw-text-opacity, 1))
}
.text-purple-900 {
    --tw-text-opacity: 1;
    color: rgba(88, 28, 135, 1);
    color: rgba(88, 28, 135, var(--tw-text-opacity, 1))
}
.text-white {
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--tw-text-opacity, 1))
}
.antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale
}
.placeholder-gray-400::placeholder {
    --tw-placeholder-opacity: 1;
    color: rgba(156, 163, 175, 1);
    color: rgba(156, 163, 175, var(--tw-placeholder-opacity, 1))
}
.opacity-25 {
    opacity: 0.25
}
.opacity-75 {
    opacity: 0.75
}
.shadow {
    --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow)
}
.shadow-2xl {
    --tw-shadow: 0 2px 5px 0 rgba(19,33,50,0.1), 0 17px 42px 0 rgba(19,33,50,0.10);
    --tw-shadow-colored: 0 2px 5px 0 var(--tw-shadow-color), 0 17px 42px 0 var(--tw-shadow-color);
    box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow)
}
.shadow-sm {
    --tw-shadow: 0 1px 3px 0 rgba(19,33,50,0.15);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color);
    box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow)
}
.shadow-xl {
    --tw-shadow: 0 1px 3px 0 rgba(19,33,50,0.1), 0 15px 35px 0 rgba(19,33,50,0.10);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 15px 35px 0 var(--tw-shadow-color);
    box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow)
}
.shadow-gray-900\\/10 {
    --tw-shadow-color: rgba(17, 24, 39, 0.1);
    --tw-shadow: var(--tw-shadow-colored)
}
.blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.invert {
    --tw-invert: invert(100%);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.transition {
    transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms
}
.\\[font-feature-settings\\:\\'ss01\\'\\] {
    font-feature-settings: 'ss01'
}
.hover\\:border-gray-400:hover {
    --tw-border-opacity: 1;
    border-color: rgba(156, 163, 175, 1);
    border-color: rgba(156, 163, 175, var(--tw-border-opacity, 1))
}
.hover\\:bg-blue-500:hover {
    --tw-bg-opacity: 1;
    background-color: rgba(59, 130, 246, 1);
    background-color: rgba(59, 130, 246, var(--tw-bg-opacity, 1))
}
.hover\\:bg-gray-50:hover {
    --tw-bg-opacity: 1;
    background-color: rgba(249, 250, 251, 1);
    background-color: rgba(249, 250, 251, var(--tw-bg-opacity, 1))
}
.focus\\:border-blue-500:focus {
    --tw-border-opacity: 1;
    border-color: rgba(59, 130, 246, 1);
    border-color: rgba(59, 130, 246, var(--tw-border-opacity, 1))
}
.focus\\:bg-white:focus {
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, 1);
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity, 1))
}
.focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px
}
.focus\\:ring-2:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 rgba(0,0,0,0);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0,0,0,0))
}
.focus\\:ring-blue-500:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgba(59, 130, 246, var(--tw-ring-opacity, 1))
}
.focus\\:ring-offset-2:focus {
    --tw-ring-offset-width: 2px
}
.focus-visible\\:outline.focus-visible {
    outline-style: solid
}
.focus-visible\\:outline:focus-visible {
    outline-style: solid
}
.focus-visible\\:outline-2.focus-visible {
    outline-width: 2px
}
.focus-visible\\:outline-2:focus-visible {
    outline-width: 2px
}
.focus-visible\\:outline-offset-2.focus-visible {
    outline-offset: 2px
}
.focus-visible\\:outline-offset-2:focus-visible {
    outline-offset: 2px
}
.focus-visible\\:outline-gray-900.focus-visible {
    outline-color: #111827
}
.focus-visible\\:outline-gray-900:focus-visible {
    outline-color: #111827
}
.disabled\\:cursor-not-allowed:disabled {
    cursor: not-allowed
}
.disabled\\:opacity-50:disabled {
    opacity: 0.5
}
@media (min-width: 640px) {
    .sm\\:col-span-2 {
        grid-column: span 2 / span 2
    }
    .sm\\:mx-0 {
        margin-left: 0px;
        margin-right: 0px
    }
    .sm\\:ml-3 {
        margin-left: 0.75rem
    }
    .sm\\:mt-0 {
        margin-top: 0px
    }
    .sm\\:contents {
        display: contents
    }
    .sm\\:w-auto {
        width: auto
    }
    .sm\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr))
    }
    .sm\\:rounded-xl {
        border-radius: .935rem
    }
    .sm\\:px-10 {
        padding-left: 2.5rem;
        padding-right: 2.5rem
    }
    .sm\\:px-6 {
        padding-left: 1.5rem;
        padding-right: 1.5rem
    }
    .sm\\:py-12 {
        padding-top: 3rem;
        padding-bottom: 3rem
    }
    .sm\\:text-sm {
        font-size: 0.875rem;
        line-height: 1.5rem
    }
}
@media (min-width: 768px) {
    .md\\:px-28 {
        padding-left: 7rem;
        padding-right: 7rem
    }
}`, "",{"version":3,"sources":["webpack://./styles/tailwind.css"],"names":[],"mappings":"AAAA;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,wCAAc;IAAd,0CAAc;IAAd,mCAAc;IAAd,8BAAc;IAAd,sCAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,wCAAc;IAAd,0CAAc;IAAd,mCAAc;IAAd,8BAAc;IAAd,sCAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AAEd;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wBAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB,2DAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB,oCAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB,oCAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB,oCAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB,oCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB,wCAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB,sCAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB,wCAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB,wCAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB,qCAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB,sCAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB,wCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,4DAAmB;IAAnB,uEAAmB;IAAnB;AAAmB;AAAnB;IAAA,4DAAmB;IAAnB,sEAAmB;IAAnB;AAAmB;AAAnB;IAAA,4DAAmB;IAAnB,sEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,mCAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,8EAAmB;IAAnB,8FAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA,8EAAmB;IAAnB,6FAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA,4CAAmB;IAAnB,uDAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA,8EAAmB;IAAnB,6FAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA,wCAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wKAAmB;IAAnB,wJAAmB;IAAnB,gNAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAFnB;IAAA,sBAEoB;IAFpB,oCAEoB;IAFpB;AAEoB;AAFpB;IAAA,kBAEoB;IAFpB,uCAEoB;IAFpB;AAEoB;AAFpB;IAAA,kBAEoB;IAFpB,wCAEoB;IAFpB;AAEoB;AAFpB;IAAA,sBAEoB;IAFpB,mCAEoB;IAFpB;AAEoB;AAFpB;IAAA,kBAEoB;IAFpB,wCAEoB;IAFpB;AAEoB;AAFpB;IAAA,8BAEoB;IAFpB;AAEoB;AAFpB;IAAA,2GAEoB;IAFpB,yGAEoB;IAFpB,kFAEoB;IAFpB;AAEoB;AAFpB;IAAA,oBAEoB;IAFpB;AAEoB;AAFpB;IAAA;AAEoB;AAFpB;IAAA;AAEoB;AAFpB;IAAA;AAEoB;AAFpB;IAAA;AAEoB;AAFpB;IAAA;AAEoB;AAFpB;IAAA;AAEoB;AAFpB;IAAA;AAEoB;AAFpB;IAAA;AAEoB;AAFpB;IAAA;AAEoB;AAFpB;IAAA;AAEoB;AAFpB;IAAA;AAEoB;AAFpB;IAAA;QAAA;IAEoB;IAFpB;QAAA,gBAEoB;QAFpB;IAEoB;IAFpB;QAAA;IAEoB;IAFpB;QAAA;IAEoB;IAFpB;QAAA;IAEoB;IAFpB;QAAA;IAEoB;IAFpB;QAAA;IAEoB;IAFpB;QAAA;IAEoB;IAFpB;QAAA,oBAEoB;QAFpB;IAEoB;IAFpB;QAAA,oBAEoB;QAFpB;IAEoB;IAFpB;QAAA,iBAEoB;QAFpB;IAEoB;IAFpB;QAAA,mBAEoB;QAFpB;IAEoB;AAAA;AAFpB;IAAA;QAAA,kBAEoB;QAFpB;IAEoB;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
